
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

/**
 * Method for footer composition
 */
function footerComposition () {
	const router = useRouter();

	// Function to navigate home
    function navigateHome (): void {
        router.push('/');
    }

	return { navigateHome }
}

export default defineComponent({
	setup() {
		return { ...footerComposition() }
	},
})
